var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotPotato({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c.4 2.1 1.7 3.2 2.9 4.3C16.2 7 17 8.2 17 9.8c0 1-.4 1.9-1 2.6-.1-1.4-.9-2.4-2.1-3.2-.1 1.2-.6 2-1.4 2.7-.5.5-.9 1-.9 1.7 0 .3.1.6.2.9A3.6 3.6 0 0 1 7 10.2c0-1.8 1-3 2.1-4.1C10.2 5 11.3 3.9 12 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2c3.9 0 7.3 1.9 7.3 5s-3.4 5.3-7.3 5.3-7.3-2.2-7.3-5.3 3.4-5 7.3-5Zm-3 3.9a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm6 0a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm-3 2.3c-.9 0-1.6.4-2.1.9l.9.9c.3-.3.7-.5 1.2-.5s.9.2 1.2.5l.9-.9c-.5-.5-1.2-.9-2.1-.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotPotato);
export default __webpack_public_path__ + "static/media/hot-potato.8476371a.svg";
export { ForwardRef as ReactComponent };